import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tryout-fee-total-income',
  templateUrl: './tryout-fee-total-income.component.html',
  styleUrls: ['./tryout-fee-total-income.component.css']
})
export class TryoutFeeTotalIncomeComponent implements OnInit {
  @Input() NoOfTotalIncome: string;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-fee-total-income/tryout-fee-total-income.component.ts